import { ClientType } from '@common/model/client/clientType';
import { createEventFactory, createName } from '@cp/shared/tracking';
import { CAREER_ID_TO_CAREER_NAME } from 'src/shared/tracking';

export const ClientSelectCareer = createEventFactory<Record<string, string>, number>(
  {
    name: createName('registration', 'career', 'select'),
    goalId: 'vybor_varianta_kategorii_specialista_v_popape',
    goalName: 'Выбор варианта категории специалиста в попапе',
  },
  (careerId) => ({
    'категория': CAREER_ID_TO_CAREER_NAME[careerId],
  }),
);

export const registrationClientTypeSelect = createEventFactory<Record<string, string>, { type: ClientType }>(
  {
    name: createName('registration', 'clientType', 'select'),
    goalId: 'vybor_varianta_ya_ishchu_pri_registracii',
    goalName: 'Выбор варианта "Я ищу" при регистрации',
  },
  ({ type }) => {
    return { type: type === ClientType.Employer ? 'помощника' : 'работу' };
  },
);

export const registration = createEventFactory({
  name: createName('registration', 'career'),
  nonInteraction: true,
  goalId: 'poyavlenie_popapa_kategoriya_specialista_',
  goalName: 'Появление попапа "Категория специалиста"',
});

export const registraionShowAddress = createEventFactory({
  name: createName('registration', 'address', 'show'),
  nonInteraction: true,
  goalId: 'poyavlenie_popapa_adres_pri_registracii',
  goalName: 'Появление попапа "Адрес" при регистрации',
});

export const registrationCitySelect = createEventFactory<{ city: number }>({
  name: createName('registration', 'city', 'select'),
  goalId: 'vybor_goroda_pri_registracii',
  goalName: 'Выбор города при регистрации',
});

export const registrationStreetSelect = createEventFactory({
  name: createName('registration', 'street', 'select'),
  goalId: 'vybor_ulicy_pri_registracii',
  goalName: 'Выбор улицы при регистрации',
});

export const registrationLocationNext = createEventFactory({
  name: createName('registration', 'locationNext', 'click'),
  goalId: 'nazhatie_knopki_dalee_pri_vybore_lokacii',
  goalName: 'Нажатие кнопки "Далее" при выборе локации',
});

export const registrationWelcomeShow = createEventFactory({
  name: createName('registration', 'welcome'),
  goalId: 'poyavlenie_popapa_s_instrukciej',
  goalName: 'Появление попапа с инструкцией',
});
export const registrationStartClick = createEventFactory({
  name: createName('registration', 'start', 'click'),
  goalId: 'nazhatie_na_knopku_davajte_nachnem',
  goalName: 'Нажатие на кнопку "Давайте начнем!"',
});

export const acquaintancePopupVisible = createEventFactory({
  name: createName('registration', 'acquaintance', 'start'),
  nonInteraction: true,
  goalName: 'Появление попапа "Как к вам обращаться?"',
  goalId: 'poyavlenie_popapa_kak_k_vam_obrashchatsya',
});

export const aquaintanceSubmit = createEventFactory({
  name: createName('registration', 'aquaintance', 'submit'),
  goalId: 'nazhatie_na_knopku_sohranit_i_prodolzhit',
  goalName: 'Нажатие на кнопку "Сохранить и продолжить"',
});

export const afterAllShow = createEventFactory({
  name: createName('registration', 'afterAll'),
  nonInteraction: true,
  goalId: 'poyavlenie_popapa_s_dalnejshimi_shagami',
  goalName: 'Появление попапа с дальнейшими шагами',
});

export const createResumeClick = createEventFactory({
  name: createName('registration', 'resume', 'create'),
  goalName: 'Нажатие на кнопку "Создать анкету"',
  goalId: 'nazhatie_na_knopku_sozdat_anketu',
});
